import React from "react";
import Button from "../button/button";
import ArrowRigth from "../icons/ArrowRigth";

import "./GoBackLink.scss";

interface GoBackLinkProps {
    text: string;
    className?: string;
    link?: string;
    onClickAction?: () => void;
}
const GoBackLink = ({
    text,
    className,
    link,
    onClickAction,
}: GoBackLinkProps) => {
    return (
        <div className={`a-go-back-link ${className || ""}`}>
            <Button
                classname="a-go-back-link__button"
                type={link ? "link" : "button"}
                href={link}
                text={text}
                isDisabled={undefined}
                onClickAction={onClickAction}
            >
                <ArrowRigth />
            </Button>
        </div>
    );
};

export default GoBackLink;
